/** PendPay brand palette — aligned with mobile */
export const darkColors = {
  bg: "#0B1120",
  surface: "#0D1526",
  card: "#101C2E",
  cardMid: "#122033",
  border: "#1A2D42",
  borderBright: "#1F3650",
  lime: "#2EC4A0",
  limeDim: "#2EC4A018",
  limeDark: "#1E8F75",
  forest: "#091828",
  forestMid: "#0F2035",
  forestBright: "#152840",
  text: "#E8F4F8",
  textMid: "#A0C4CC",
  muted: "#4A7A8A",
  danger: "#FF5252",
  dangerDim: "#FF525215",
  gold: "#F0C060",
  goldDim: "#F0C06015",
  info: "#60BFFF",
};

export const lightColors = {
  bg: "#F0F4F8",
  surface: "#FFFFFF",
  card: "#FFFFFF",
  cardMid: "#F5F8FA",
  border: "#D8E4EC",
  borderBright: "#C5D6E2",
  lime: "#2EC4A0",
  limeDim: "#2EC4A018",
  limeDark: "#1E8F75",
  forest: "#091828",
  forestMid: "#E8F2F6",
  forestBright: "#D4E8EE",
  text: "#0B1120",
  textMid: "#3A5A6A",
  muted: "#6A8A9A",
  danger: "#E03939",
  dangerDim: "#E0393915",
  gold: "#C8960A",
  goldDim: "#C8960A15",
  info: "#2080D0",
};

export function getColors(mode) {
  return mode === "light" ? lightColors : darkColors;
}
